<ng-container *ngIf="attachment">
  <div class="attachment-container">
    <div class="document-header">
      <span class="document-title">{{ attachment.name }}</span>
      <div class="action-buttons">
        <button class="action-button" [attr.aria-label]="'Download ' + attachment.name" (click)="onDownloadClick(attachment)">
          <rkt-icon name="download"></rkt-icon>
        </button>
        <button class="action-button" aria-label="Close preview" (click)="activeModal.close()"><rkt-icon name="times"></rkt-icon></button>
      </div>
    </div>

    <div class="scroll-wrapper">
      <ngx-extended-pdf-viewer
        *ngIf="isPdf && !hasLoadError; else fallback"
        [src]="attachment.url!"
        [useInlineScripts]="false"
        [showBorders]="false"
        [showToolbar]="false"
        [textLayer]="false"
        [sidebarVisible]="false"
        backgroundColor="#282828"
        [zoom]="'page-width'"
        (pageChange)="onPageChange($event)"
        (pagesLoaded)="onPagesLoaded($event)"
        (pdfLoaded)="onPdfLoaded()"
        (pdfLoadingFailed)="onPdfLoadingFailed($event)"
      >
      </ngx-extended-pdf-viewer>

      <div *ngIf="isLoading" class="preview-loading">
        <app-loading-screen loadingMessage="Loading document..." />
      </div>

      <ng-template #fallback>
        <!-- Figma 8280:6990 (KOR-15207); downloading stays available from the header -->
        <div *ngIf="hasLoadError; else imagePreview" class="load-error" role="alert">
          <svg class="load-error-icon" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M10.3 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.7 3.86a2 2 0 0 0-3.4 0Z" stroke-linejoin="round" />
            <path d="M12 9v4M12 17h.01" stroke-linecap="round" />
          </svg>
          <p class="load-error-title">Preview unavailable</p>
          <p class="load-error-text">We couldn’t load this document.</p>
        </div>
      </ng-template>

      <ng-template #imagePreview>
        <div class="image-preview">
          <img [src]="attachment.url" [alt]="attachment.name" (error)="onImageError()" />
        </div>
      </ng-template>
    </div>
  </div>
</ng-container>
